import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "72",
        height: "72",
        viewBox: "0 0 72 72",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M36 57V16",
                stroke: "#03D883",
                "stroke-width": "2",
                "stroke-linecap": "square",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15 36L36 15L57 36",
                stroke: "#03D883",
                "stroke-width": "2",
                "stroke-linecap": "square",
                "stroke-linejoin": "round"
            })
        ]
    });
};
export default Icon;
